import { PDFDocument } from 'pdf-lib';

export const mergePDFs = async (files) => {
    const mergedPdf = await PDFDocument.create();

    for (const file of files) {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await PDFDocument.load(arrayBuffer);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
        copiedPages.forEach((page) => mergedPdf.addPage(page));
    }

    const mergedPdfBytes = await mergedPdf.save();
    return new File([mergedPdfBytes], 'merged.pdf', { type: 'application/pdf' });
};

export const splitPDF = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);
    const pageCount = pdf.getPageCount();
    const splitPdfs = [];

    for (let i = 0; i < pageCount; i++) {
        const newPdf = await PDFDocument.create();
        const [copiedPage] = await newPdf.copyPages(pdf, [i]);
        newPdf.addPage(copiedPage);

        const pdfBytes = await newPdf.save();
        const fileName = file.name.replace('.pdf', `_page_${i + 1}.pdf`);
        splitPdfs.push(new File([pdfBytes], fileName, { type: 'application/pdf' }));
    }

    return splitPdfs;
};

export const rotatePDF = async (file, degrees) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);
    const pages = pdf.getPages();

    pages.forEach(page => {
        page.setRotation({ angle: degrees, type: 'degrees' });
    });

    const pdfBytes = await pdf.save();
    return new File([pdfBytes], file.name, { type: 'application/pdf' });
};

export const deletePDFPages = async (file, pageIndices) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);

    // Sort in descending order to avoid index shifting
    const sortedIndices = [...pageIndices].sort((a, b) => b - a);

    for (const index of sortedIndices) {
        pdf.removePage(index);
    }

    const pdfBytes = await pdf.save();
    return new File([pdfBytes], file.name, { type: 'application/pdf' });
};

export const reorderPDFPages = async (file, newOrder) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);
    const newPdf = await PDFDocument.create();

    for (const pageIndex of newOrder) {
        const [copiedPage] = await newPdf.copyPages(pdf, [pageIndex]);
        newPdf.addPage(copiedPage);
    }

    const pdfBytes = await newPdf.save();
    return new File([pdfBytes], file.name, { type: 'application/pdf' });
};

export const getPDFPageCount = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await PDFDocument.load(arrayBuffer);
    return pdf.getPageCount();
};
